import ContentJoin from "@/components/Shared/BlogContentJoin";
import vector from "@/assets/blog/blog-bottom.png";
import localizePath from "@/functions/localizePath";
import useLocale from "@/hooks/useLocale";

export default function BlogsContainer() {
  const locale = useLocale();

  return (
    <div className="relative pb-[100px] mt-[50px]">
      <div className="flex flex-col items-center gap-10 sm:gap-[79px] relative z-[5]">
        <ContentJoin
          content={{
            title: "Looking for your next role in technology?",
            info: ` We’ve been helping clients achieve the results they need for over 20 years. In that time, we’ve refined ou. We’ve been helping clients achieve the results they need for over 20 years. In that time, we’ve.`,
          }}
          path="article"
        />
      </div>
      <img src={vector ?? ""} alt="vector" className="absolute bottom-0" />
    </div>
  );
}
